import React, { useState, useRef, useEffect } from 'react';
import { FiSend } from 'react-icons/fi';
import { BsRobot } from 'react-icons/bs';
import { FaUser } from 'react-icons/fa';
import { Input, Button, Spin } from 'antd';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { oneDark } from 'react-syntax-highlighter/dist/esm/styles/prism';
import styles from './ChatIntelect.module.css';


const ChatIntelect = () => {
    const [messages, setMessages] = useState([]);
    const [inputText, setInputText] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const messagesEndRef = useRef(null);

    const scrollToBottom = () => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    };

    useEffect(() => {
        scrollToBottom();
    }, [messages]);

    const handleSend = async () => {
        if (!inputText.trim()) return;

        const userMessage = {
            text: inputText,
            isUser: true,
            timestamp: new Date().toISOString(),
        };

        setMessages(prev => [...prev, userMessage]);
        setInputText('');
        setIsLoading(true);

        try {
            const response = await fetch('https://api.familybook.uz/api/chat', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ message: inputText }),
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const data = await response.json();
            
            const aiResponse = {
                text: data.reply || "Kechirasiz, javob qaytarishda xatolik yuz berdi.",
                isUser: false,
                timestamp: new Date().toISOString(),
            };
            setMessages(prev => [...prev, aiResponse]);
        } catch (error) {
            console.error('Error:', error);
            const errorResponse = {
                text: "Xatolik yuz berdi. Iltimos qaytadan urinib ko'ring.",
                isUser: false,
                timestamp: new Date().toISOString(),
            };
            setMessages(prev => [...prev, errorResponse]);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className={styles.chatContainer}>
            <div className={styles.messagesContainer}>
                {messages.map((message, index) => (
                    <div 
                        key={index} 
                        className={`${styles.messageRow} ${message.isUser ? styles.userRow : ''}`}
                    >
                        <div className={`${styles.iconWrapper} ${message.isUser ? styles.userIcon : ''}`}>
                            {message.isUser ? <FaUser /> : <BsRobot />}
                        </div>
                        <div 
                            className={`${styles.messageBubble} ${message.isUser ? styles.userBubble : ''}`}
                        >
                            {message.isUser ? message.text : (
                                <ReactMarkdown
                                    remarkPlugins={[remarkGfm]}
                                    components={{
                                        code({ node, inline, className, children, ...props }) {
                                            const match = /language-(\w+)/.exec(className || '');
                                            return !inline && match ? (
                                                <SyntaxHighlighter
                                                    style={oneDark}
                                                    language={match[1]}
                                                    PreTag="div"
                                                    {...props}
                                                >
                                                    {String(children).replace(/\n$/, '')}
                                                </SyntaxHighlighter>
                                            ) : (
                                                <code className={className} {...props}>
                                                    {children}
                                                </code>
                                            );
                                        },
                                    }}
                                >
                                    {message.text}
                                </ReactMarkdown>
                            )}
                        </div>
                    </div>
                ))}
                {isLoading && (
                    <div className={styles.messageRow}>
                        <div className={styles.iconWrapper}>
                            <BsRobot />
                        </div>
                        <div className={styles.messageBubble}>
                            <Spin size="small" /> Javob yozilmoqda...
                        </div>
                    </div>
                )}
                <div ref={messagesEndRef} />
            </div>
            <div className={styles.inputContainer}>
                <Input
                    placeholder="Xabaringizni yozing..."
                    value={inputText}
                    onChange={(e) => setInputText(e.target.value)}
                    onPressEnter={handleSend}
                    size="large"
                />
                <Button
                    type="primary"
                    icon={<FiSend />}
                    onClick={handleSend}
                    size="large"
                >
                    Yuborish
                </Button>
            </div>
        </div>
    );
};

export default ChatIntelect;